import { useRouter } from 'next/router';
import { useMemo } from 'react';
import type { FormatJobType, JobCategory } from '@/api/cms/jobs/types';
import type { DefaultCmsDataResponse, Location } from '@/api/cms/types';
import IconX from '@/public/static/icons/Close.svg';
type Props = {
  jobTypes: DefaultCmsDataResponse<FormatJobType>[];
  locations: DefaultCmsDataResponse<Location>[];
  jobCategories: DefaultCmsDataResponse<JobCategory>[];
};
const ListChipSelection = ({ jobTypes, locations, jobCategories }: Props) => {
  const router = useRouter();
  const { team, location, level, is_hot, is_new } = router.query;
  const statusSelected = useMemo(() => {
    return `${is_hot ? '1' : ''},${is_new ? '2' : ''}`;
  }, [is_hot, is_new]);
  const listStatus = useMemo(() => {
    return [
      {
        id: 1,
        name: 'Hot Job',
      },
      {
        id: 2,
        name: 'New Job',
      },
    ];
  }, []);
  const combineAndTransformData = (
    jobTypes: DefaultCmsDataResponse<FormatJobType>[],
    jobCategories: DefaultCmsDataResponse<JobCategory>[],
    locations: DefaultCmsDataResponse<Location>[],
    status: {
      id: number;
      name: string;
    }[],
    allObj: {
      id: number;
      name: string;
    }[]
  ): { id: number; name: string }[] => {
    const combinedData = [
      ...jobTypes,
      ...jobCategories,
      ...locations,
      ...status,
      ...allObj,
    ].map((item) => {
      if ('attributes' in item) {
        return { id: item.id, name: item.attributes.name };
      } else {
        return { id: item.id, name: item.name };
      }
    });
    return combinedData;
  };
  const allObj = [
    {
      id: 0,
      name: 'Tất cả',
    },
  ];
  const combinedData = combineAndTransformData(
    jobTypes,
    jobCategories,
    locations,
    listStatus,
    allObj
  );

  const dataSelected = combinedData.filter((item) => {
    let teamArr: string | string[] = [];
    let locationArr: string[] = [];
    let levelArr: string[] = [];
    let statusArr: string[] = [];

    if (team) {
      teamArr = (team as string).split(',');
    }
    if (location) {
      locationArr = (location as string).split(',');
    }
    if (level) {
      levelArr = (level as string).split(',');
    }
    if (statusSelected) {
      statusArr = (statusSelected as string).split(',');
    }
    const teamArray = Array.isArray(teamArr) ? teamArr : [team];
    const locationArray = Array.isArray(locationArr) ? locationArr : [location];
    const levelArray = Array.isArray(levelArr) ? levelArr : [level];
    const statusArray = Array.isArray(statusArr) ? statusArr : [statusSelected];

    const dataReturn =
      teamArray.includes(item.id.toString()) ||
      locationArray.includes(item.id.toString()) ||
      levelArray.includes(item.id.toString()) ||
      statusArray.includes(item.id.toString());

    return dataReturn;
  });

  const handleRemoveID = (idToRemove: string) => {
    const query = { ...router.query };
    const removeIDFromArray = (field: string, id: string) => {
      if (field === 'status') {
        // Check if idToRemove is 1 or 2
        if (id === '1') {
          delete query['is_hot'];
        } else if (id === '2') {
          delete query['is_new'];
        }
      }
      if (query && field) {
        if (query[field]) {
          let tesst: string[] = [];
          tesst = Array.isArray(query[field])
            ? (query[field] as string[])
            : query[field]
            ? ([query[field]] as string[])
            : [];
          tesst = tesst.map((item) => item.split(',')).flat();
          query[field] = tesst.filter((item: string) => item !== id);
          query[field] = [(query[field] as string[]).join(',')];
        } else if (query[field] === id) {
          delete query[field];
        }
      }
    };

    removeIDFromArray('team', idToRemove);
    removeIDFromArray('location', idToRemove);
    removeIDFromArray('level', idToRemove);
    removeIDFromArray('status', idToRemove);
    router.replace({ query }, undefined, { shallow: true });
  };
  const handleClearAll = () => {
    const query = { ...router.query };
    delete query.team;
    delete query.location;
    delete query.level;
    delete query.status;
    delete query.is_hot;
    delete query.is_new;

    router.replace({ query }, undefined, { shallow: true });
  };

  const isDataSelectedSingle = dataSelected.length === 1;

  if (
    team === undefined &&
    location === undefined &&
    level === undefined &&
    is_hot === undefined &&
    is_new === undefined
  ) {
    return null;
  }
  return (
    <>
      <div className="flex flex-wrap gap-2">
        {dataSelected &&
          dataSelected.length > 0 &&
          dataSelected.map((item) => {
            return (
              <div
                key={item.id}
                className="flex items-center justify-between gap-[4px] rounded-[6px] bg-[#F3F4F6] py-[4px] px-[8px] align-middle text-[12px] font-semibold text-[#4B5563]"
              >
                {item.name}
                <button
                  onClick={() => {
                    if (isDataSelectedSingle) {
                      handleClearAll();
                    } else {
                      handleRemoveID(item.id.toString());
                    }
                  }}
                >
                  <IconX size={14} color="#4B5563" />
                </button>
              </div>
            );
          })}
        <button
          type="button"
          className="flex items-center justify-between gap-[6px] rounded-[6px] bg-[#FEE2E2] py-[4px] px-[8px] align-middle text-[12px] font-semibold text-[#B91C1C]"
          onClick={() => {
            handleClearAll();
          }}
        >
          Xoá tất cả
          <IconX size={14} color="#B91C1C" />
        </button>
      </div>
    </>
  );
};

export default ListChipSelection;
